import { useDispatch, useSelector } from "react-redux"
import PageContainer from "../components/PageContainer"
import CartProductCard from "../components/shopOrders/CartProductCard"
import PageTitle from "../components/PageTitle";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { setBacklink } from "../redux/backlinkSlice";

const Cart = () => {
    const { t } = useTranslation();
    const { data } = useSelector(state => state.cart)
    const [totalPrice, setTotalPrice] = useState(null);
    const handleTotalPrice = () => {
        let total = 0;
        data.forEach(element => {
            total += (element.price * element.quantity)
        });
        setTotalPrice(total.toFixed(2));
    }
    useEffect(() => {
        if (data) {
            handleTotalPrice();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    // Setto il backlink al click su checkout
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleClickCheckout = () => {
        dispatch(setBacklink("/cart"));
        navigate(`/checkout`);
    }
    return (
        <PageContainer desktopItems="center">
            <PageTitle title="Il tuo carrello" backLink="/" />
            <div className="flex flex-col gap-4 items-center">
                {
                    data && data.length > 0 && data.map((element, index) => {
                        return <CartProductCard key={index} purchaseData={element} />
                    })
                }
                {
                    data && data.length === 0 &&
                    <h3>{t('Cart.cartEmpty')}</h3>
                }
                {
                    data && data.length > 0 &&
                    <div className="w-full md:w-[600px] flex gap-2 justify-between text-2xl px-4">
                        <div>Totale:</div>
                        <div>CHF {totalPrice}</div>
                    </div>
                }

                <div className="flex gap-2">
                    <Link to="/shop"><button className="border-2 rounded-xl py-2 px-4 border-[#225424]">{t('Cart.backToShop')}</button></Link>
                    {data && data.length > 0 && <button className="border-2 rounded-xl py-2 px-4 bg-[#225424] text-white" onClick={handleClickCheckout}>{t('Cart.goToCheckout')}</button>}
                </div>
            </div>
        </PageContainer>
    )
}

export default Cart